let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8kvJc")).then(() => parcelRequire('kTkx3'));